import { State, StudioDialogTypes } from './types';
import { getInitialState } from './utils';

const mutations = {
  setOpenDialog<T extends {}>(state: State, openedDialog: StudioDialogTypes, data?: T) {
    state.openDialog = openedDialog;
    if (data) {
      state.data = data as T;
    }
  },
  setToggleOpen(state: State, isOpen: boolean) {
    state.isToggelOpen = isOpen;
  },
  clearDialogState(state) {
    state.openDialog = getInitialState().openDialog;
    state.data = getInitialState().data;
  }
};

export default mutations;
